var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25C7.39239 11.25 8.72774 10.6969 9.71231 9.71231C10.6969 8.72774 11.25 7.39239 11.25 6C11.25 4.60761 10.6969 3.27226 9.71231 2.28769C8.72774 1.30312 7.39239 0.75 6 0.75C4.60761 0.75 3.27226 1.30312 2.28769 2.28769C1.30312 3.27226 0.75 4.60761 0.75 6C0.75 7.39239 1.30312 8.72774 2.28769 9.71231C3.27226 10.6969 4.60761 11.25 6 11.25ZM6 2.625C7.8375 2.6475 9.33 4.185 9.33 6.0375V6.645C9.33 7.3125 8.7825 7.86 8.115 7.86C7.6575 7.86 7.26 7.605 7.05 7.23C6.705 7.575 6.225 7.7925 5.7 7.7925C4.65 7.7925 3.795 6.9375 3.795 5.8875C3.795 4.8375 4.65 3.9825 5.7 3.9825C6.1575 3.9825 6.57 4.1475 6.9 4.41V4.3425C6.9 4.1475 7.0725 3.99 7.2675 3.99C7.4625 3.99 7.62 4.1475 7.62 4.3425V6.6525C7.62 6.78577 7.67294 6.91358 7.76718 7.00782C7.86142 7.10206 7.98923 7.155 8.1225 7.155C8.25577 7.155 8.38358 7.10206 8.47782 7.00782C8.57206 6.91358 8.625 6.78577 8.625 6.6525V6.045C8.625 4.5675 7.44 3.3525 5.9925 3.33C5.2725 3.33 4.59 3.6 4.08 4.1025C3.57 4.605 3.285 5.28 3.285 6C3.285 7.47 4.485 8.67 5.955 8.67C6.04849 8.67 6.13815 8.70714 6.20426 8.77324C6.27036 8.83935 6.3075 8.92901 6.3075 9.0225C6.3075 9.11599 6.27036 9.20565 6.20426 9.27176C6.13815 9.33786 6.04849 9.375 5.955 9.375C4.095 9.375 2.58 7.86 2.58 6C2.58 5.0925 2.9325 4.2375 3.585 3.6C4.23 2.955 5.0925 2.61 6 2.625Z",
    fill: "url(#paint0_linear_108_567)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_567",
    x1: 6,
    y1: 0.75,
    x2: 6,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF961A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1908"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.659abe844c0e74f48370313f573e762c.svg";
export { ForwardRef as ReactComponent };